/** Français. Les clés manquantes reviennent au néerlandais. */
import type { Woordenboek } from '../index.ts';

export const fr: Partial<Woordenboek> = {
  'app.naam': 'Mizen',
  'algemeen.opslaan': 'Enregistrer',
  'algemeen.annuleren': 'Annuler',
  'algemeen.sluiten': 'Fermer',
  'algemeen.verwijderen': 'Supprimer',
  'algemeen.bewerken': 'Modifier',
  'algemeen.terug': 'Retour',
  'algemeen.volgende': 'Suivant',
  'algemeen.zoeken': 'Rechercher',
  'algemeen.laden': 'Chargement',
  'algemeen.leeg': 'Rien pour le moment',
  'algemeen.fout': 'Une erreur est survenue',
  'algemeen.opnieuw': 'Réessayer',
  'algemeen.totaal': 'Total',
  'algemeen.datum': 'Date',
  'algemeen.bedrag': 'Montant',
  'algemeen.omschrijving': 'Description',
  'algemeen.status': 'Statut',
  'algemeen.aantal': 'Quantité',
  'algemeen.prijs': 'Prix',
  'algemeen.btw': 'TVA',
  'algemeen.meer': 'Plus',
  'algemeen.van': 'du',
  'algemeen.tot': "jusqu'au",
  'algemeen.periode': 'Période',
  'algemeen.ja': 'Oui',
  'algemeen.nee': 'Non',
  'algemeen.verplicht': 'Ce champ est obligatoire',
  'algemeen.exporteren': 'Exporter',
  'algemeen.downloaden': 'Télécharger',

  'nav.dashboard': "Vue d'ensemble",
  'nav.verkoop': 'Factures',
  'nav.uren': 'Suivi du temps',
  'nav.inkoop': 'Reçus et achats',
  'nav.bank': 'Banque',
  'nav.relaties': 'Clients et fournisseurs',
  'nav.rapporten': 'Chiffres',
  'nav.instellingen': 'Paramètres',

  // Korte varianten voor de tabbalk op een telefoon, waar de volledige naam
  // niet leesbaar past.
  'nav.kort.dashboard': 'Accueil',
  'nav.kort.verkoop': 'Factures',
  'nav.kort.uren': 'Temps',
  'nav.kort.inkoop': 'Achats',
  'nav.kort.bank': 'Banque',
  'nav.kort.relaties': 'Contacts',
  'nav.kort.rapporten': 'Chiffres',
  'nav.kort.instellingen': 'Réglages',
  'nav.hoofdmenu': 'Menu principal',
  'nav.naarInhoud': 'Aller au contenu',
  'nav.administratieKiezen': 'Choisir un dossier',
  'nav.afmelden': 'Se déconnecter',
  // Environnement de test et retours
  'omgeving.test': 'Environnement de test',
  'omgeving.testUitleg':
    'Ceci est une version d essai, a regarder et a evaluer. Les donnees sont fictives ; n y mettez pas une vraie comptabilite.',
  'feedback.knop': 'Une remarque ?',
  'feedback.titel': 'Qu est-ce qui vous frappe ?',
  'feedback.uitleg':
    'Notez ce qui vous frappe, meme un detail. Nous enregistrons l ecran ou vous etiez, vous n avez pas a l expliquer.',
  'feedback.soort': 'De quoi s agit-il ?',
  'feedback.soort.opmerking': 'Une remarque',
  'feedback.soort.fout': 'Quelque chose ne va pas',
  'feedback.soort.wens': 'Ce que j aimerais',
  'feedback.soort.vraag': 'Une question',
  'feedback.bericht': 'Votre remarque',
  'feedback.naam': 'Votre nom',
  'feedback.naamUitleg': 'Uniquement si nous pouvons revenir vers vous.',
  'feedback.versturen': 'Envoyer',
  'feedback.verstuurd': 'Merci. Votre remarque est notee.',
  'feedback.overzicht': 'Remarques',
  'feedback.leeg': 'Aucune remarque pour le moment.',
  'feedback.leegUitleg': 'Des que quelqu un remarque quelque chose, cela apparait ici.',
  'feedback.scherm': 'Ecran',
  'feedback.wie': 'De',
  'feedback.wanneer': 'Quand',
  'feedback.antwoord': 'Reponse',
  'feedback.antwoordPlaatsen': 'Noter une reponse',
  'feedback.status.nieuw': 'Nouveau',
  'feedback.status.opgepakt': 'Pris en charge',
  'feedback.status.verwerkt': 'Traite',
  'feedback.status.afgewezen': 'Non retenu',
  'feedback.aantalNieuw': 'nouveau',
  'feedback.alles': 'Tout',

  'auth.aanmelden': 'Se connecter',
  'auth.registreren': 'Créer un compte',
  'auth.email': 'Adresse e-mail',
  'auth.wachtwoord': 'Mot de passe',
  'auth.naam': 'Votre nom',
  'auth.wachtwoordEis': 'Au moins 12 caractères. Une courte phrase fonctionne bien et se retient facilement.',
  'auth.nogGeenAccount': 'Pas encore de compte ? Créez-en un.',
  'auth.welAccount': 'Vous avez déjà un compte ? Connectez-vous.',
  'auth.mfaTitel': 'Encore une étape',
  'auth.mfaUitleg':
    "Saisissez le code à six chiffres de votre application d'authentification. Sinon, utilisez un code de récupération.",
  'auth.mfaCode': 'Code',
  'auth.mfaBevestigen': 'Confirmer',
  'auth.mfaInstellen': 'Configurer la vérification en deux étapes',
  'auth.mfaUitleglang':
    "Avec la vérification en deux étapes, votre mot de passe seul ne suffit pas pour accéder à votre comptabilité. Scannez le code avec une application d'authentification.",
  'auth.mfaGeheim': 'Impossible de scanner ? Saisissez cette clé manuellement :',
  'auth.mfaHerstelcodes': 'Codes de récupération',
  'auth.mfaHerstelcodesUitleg':
    'Conservez ces codes en lieu sûr, par exemple dans un gestionnaire de mots de passe. Chaque code fonctionne une seule fois.',
  'auth.mfaAan': 'La vérification en deux étapes est activée',
  'auth.mfaUit': 'La vérification en deux étapes est désactivée',
  'auth.sessies': 'Appareils sur lesquels vous êtes connecté',
  'auth.sessiesIntrekken': 'Déconnecter les autres appareils',
  'auth.registratieGelukt': 'Votre compte a été créé. Vous pouvez vous connecter.',

  'org.nieuweOrganisatie': 'Nouvelle organisation',
  'org.naam': "Nom de l'organisation",
  'org.kvk': 'Numéro du registre du commerce',
  'org.abonnement': 'Formule',
  'admin.nieuw': 'Nouveau dossier',
  'admin.naam': "Nom de l'entreprise",
  'admin.rechtsvorm': 'Forme juridique',
  'admin.schema': 'Plan comptable',
  'admin.schemaUitleg':
    "Le plan comptable détermine où chaque montant se retrouve. Nous préparons un plan néerlandais complet ; vous pouvez l'adapter à tout moment.",
  'admin.btwNummer': 'Numéro de TVA',
  'admin.adres': 'Adresse',
  'admin.postcodePlaats': 'Code postal et ville',
  'admin.iban': 'IBAN',
  'admin.boekjaar': 'Exercice',
  'admin.kiezen': 'Choisir un dossier',
  'admin.geenAdministraties': "Vous n'avez pas encore de dossier. Créez-en un pour commencer.",
  'admin.actief': 'Vous travaillez dans',

  'dashboard.titel': 'Comment va votre entreprise ?',
  'dashboard.omzet': "Chiffre d'affaires",
  'dashboard.omzetUitleg': 'Tout ce que vous avez gagné avec votre travail ou vos produits, hors TVA.',
  'dashboard.kosten': 'Charges',
  'dashboard.kostenUitleg': 'Ce que vous avez dépensé pour réaliser votre travail, hors TVA.',
  'dashboard.winst': 'Bénéfice',
  'dashboard.winstUitleg':
    "Chiffre d'affaires moins charges. C'est là-dessus que vous êtes finalement imposé.",
  'dashboard.banksaldo': 'En banque',
  'dashboard.banksaldoUitleg':
    'Le solde selon votre comptabilité. Il peut différer de votre application bancaire tant que des opérations restent à traiter.',
  'dashboard.teOntvangen': 'Encore à recevoir',
  'dashboard.teOntvangenUitleg': 'Ce que vos clients vous doivent encore.',
  'dashboard.teBetalen': 'Encore à payer',
  'dashboard.teBetalenUitleg': 'Ce que vous devez encore à vos fournisseurs.',
  'dashboard.btw': 'TVA attendue',
  'dashboard.btwUitleg':
    "Ce que vous devriez payer ou récupérer pour cette période. Il s'agit d'un calcul, pas d'une déclaration.",
  'dashboard.aandacht': 'Cela demande votre attention',
  'dashboard.teBoeken': 'Opérations bancaires à traiter',
  'dashboard.ontbrekendeBonnen': 'Dépenses sans justificatif',
  'dashboard.geenAandacht': 'Tout est à jour. Beau travail.',
  'dashboard.vergelijking': 'par rapport à la période précédente',

  'facturen.titel': 'Factures',
  'facturen.nieuw': 'Nouvelle facture',
  'facturen.nieuweOfferte': 'Nouveau devis',
  'facturen.nummer': 'Numéro',
  'facturen.klant': 'Client',
  'facturen.factuurdatum': 'Date de facture',
  'facturen.vervaldatum': 'À payer avant le',
  'facturen.regels': 'Que livrez-vous ?',
  'facturen.regelToevoegen': 'Ajouter une ligne',
  'facturen.subtotaal': 'Sous-total',
  'facturen.totaal': 'Total à payer',
  'facturen.definitiefMaken': 'Valider',
  'facturen.definitiefUitleg':
    'La facture reçoit alors un numéro et entre dans votre comptabilité. Elle ne peut plus être modifiée ; une correction se fait par avoir.',
  'facturen.versturen': 'Envoyer au client',
  'facturen.pdf': 'Voir le PDF',
  'facturen.ubl': 'Télécharger le UBL',
  'facturen.crediteren': 'Créer un avoir',
  'facturen.status.concept': 'Brouillon',
  'facturen.status.definitief': 'Validée',
  'facturen.status.verzonden': 'Envoyée',
  'facturen.status.deels_betaald': 'Partiellement payée',
  'facturen.status.betaald': 'Payée',
  'facturen.status.vervallen': 'En retard',
  'facturen.status.geannuleerd': 'Annulée',
  'facturen.leeg': "Vous n'avez pas encore créé de facture.",
  'facturen.leegUitleg':
    'Créez votre première facture ; nous veillons à ce quelle soit correctement comptabilisée.',
  'facturen.referentie': 'Référence du client',
  'facturen.notitie': 'Note sur la facture',
  'facturen.openstaand': 'Encore dû',
  // Apercu des factures : filtres et totaux
  'facturen.zoeken': 'Rechercher par numero, client ou reference',
  'facturen.alles': 'Tout',
  'facturen.alleSoorten': 'Tous les types',
  'facturen.alleStatussen': 'Toutes les factures',
  'facturen.alleenOpenstaand': 'Impayees seulement',
  'facturen.alleenVervallen': 'En retard seulement',
  'facturen.aantalGevonden': 'trouvees',
  'facturen.totaalBedrag': 'Total facture',
  'facturen.totaalOpenstaand': 'Reste a recevoir',
  'facturen.totaalVervallen': 'Dont en retard',
  'facturen.meerLaden': 'Charger plus',
  'facturen.geenResultaat': 'Aucune facture trouvee',
  'facturen.geenResultaatUitleg': 'Modifiez votre recherche ou vos filtres.',
  'facturen.filtersWissen': 'Effacer les filtres',
  'facturen.dagenTeLaat': 'jours de retard',
  'facturen.sorteerOp': 'Trier par',
  'facturen.soort': 'Type',
  'facturen.soort.offerte': 'Devis',
  'facturen.soort.factuur': 'Facture',
  'facturen.soort.creditnota': 'Avoir',
  'facturen.soort.proforma': 'Proforma',
  'facturen.status.vervallen_offerte': 'Devis expire',

  // Suivi du temps et projets
  'uren.titel': 'Temps',
  'uren.projecten': 'Projets',
  'uren.weekstaat': 'Mes heures',
  'uren.nieuw': 'Saisir du temps',
  'uren.project': 'Projet',
  'uren.activiteit': 'Activite',
  'uren.geenActiviteit': 'Aucune activite',
  'uren.wie': 'Qui',
  'uren.duur': 'Duree',
  'uren.minuten': 'minutes',
  'uren.uur': 'heures',
  'uren.factureerbaar': 'Facturable',
  'uren.tarief': 'Taux horaire',
  'uren.urenLabel': 'Heures',
  'uren.minutenLabel': 'Minutes',
  'uren.wachtOpGoedkeuring': 'en attente d approbation',
  'uren.opslaan': 'Enregistrer le temps',
  'uren.leeg': 'Aucune heure saisie pour le moment.',
  'uren.legUitleg': 'Saisissez vos premieres heures ; vous pourrez les facturer ensemble plus tard.',
  'uren.alleenEigen': 'Vous ne voyez que vos propres heures.',
  'uren.totaalDezeWeek': 'Cette periode',
  'uren.indienen': 'Soumettre',
  'uren.goedkeuren': 'Approuver',
  'uren.afkeuren': 'Refuser',
  'uren.afkeurreden': 'Pourquoi refusez-vous ces heures ?',
  'uren.factureren': 'Facturer les heures',
  'uren.factureerUitleg':
    'Les heures approuvees deviennent un brouillon de facture. Vous le verifiez avant de le rendre definitif.',
  'uren.selectie': 'selectionnees',
  'uren.selecteerAlles': 'Tout selectionner',
  'uren.status.concept': 'Brouillon',
  'uren.status.ingediend': 'Soumis',
  'uren.status.goedgekeurd': 'Approuve',
  'uren.status.afgekeurd': 'Refuse',
  'uren.status.gefactureerd': 'Facture',
  'uren.eigenUrenNietGoedkeuren': 'Quelqu un d autre examine vos propres heures.',

  'projecten.titel': 'Projets',
  'projecten.nieuw': 'Nouveau projet',
  'projecten.naam': 'Nom du projet',
  'projecten.code': 'Code du projet',
  'projecten.klant': 'Client',
  'projecten.geenKlant': 'Aucun client',
  'projecten.facturatie': 'Comment facturer ?',
  'projecten.facturatie.uurtarief': 'Au taux horaire',
  'projecten.facturatie.vaste_prijs': 'Prix fixe',
  'projecten.facturatie.niet': 'Pas de facturation',
  'projecten.uurtarief': 'Taux horaire',
  'projecten.vastePrijs': 'Prix fixe',
  'projecten.budget': 'Budget en heures',
  'projecten.budgetUren': 'heures de budget',
  'projecten.geschreven': 'Saisi',
  'projecten.teFactureren': 'Reste a facturer',
  'projecten.gefactureerd': 'Facture',
  'projecten.status.actief': 'Actif',
  'projecten.status.op_pauze': 'En pause',
  'projecten.status.afgerond': 'Termine',
  'projecten.status.gearchiveerd': 'Archive',
  'projecten.leeg': 'Il n y a pas encore de projets.',
  'projecten.leegUitleg': 'Creez un projet ; vous pourrez ensuite y saisir des heures et les facturer.',
  'projecten.activiteiten': 'Activites',
  'projecten.activiteitToevoegen': 'Ajouter une activite',
  'projecten.budgetOp': 'Le budget est presque epuise.',
  'projecten.budgetOver': 'Le budget est depasse.',

  'relaties.titel': 'Clients et fournisseurs',
  'relaties.nieuw': 'Nouveau contact',
  'relaties.naam': 'Nom',
  'relaties.soort': 'Type',
  'relaties.klant': 'Client',
  'relaties.leverancier': 'Fournisseur',
  'relaties.beide': 'Les deux',
  'relaties.email': 'Adresse e-mail',
  'relaties.telefoon': 'Téléphone',
  'relaties.btwNummer': 'Numéro de TVA',
  'relaties.kvk': 'Numéro du registre du commerce',
  'relaties.iban': 'IBAN',
  'relaties.betalingstermijn': 'Délai de paiement en jours',
  'relaties.leeg': "Vous n'avez pas encore de clients ni de fournisseurs.",
  'relaties.dubbelWaarschuwing': 'Un contact au nom similaire existe déjà : {namen}.',
  'relaties.tochAanmaken': "Il s'agit bien d'une autre partie, créer quand même",

  'inkoop.titel': "Reçus et factures d'achat",
  'inkoop.nieuw': 'Enregistrer un reçu ou une facture',
  'inkoop.leverancier': 'Fournisseur',
  'inkoop.factuurnummer': 'Numéro de facture du fournisseur',
  'inkoop.document': 'Reçu ou facture (PDF ou photo)',
  'inkoop.documentUitleg':
    "Conservez toujours le justificatif original. C'est une obligation légale et il sera demandé en cas de contrôle.",
  'inkoop.leeg': "Vous n'avez pas encore enregistré de facture d'achat.",
  'inkoop.dubbel': 'Ce fournisseur a déjà envoyé ce numéro de facture.',

  'bank.titel': 'Banque',
  'bank.importeren': 'Importer un relevé',
  'bank.importUitleg':
    'Téléchargez un relevé auprès de votre banque (CSV, MT940 ou CAMT.053) et déposez-le ici.',
  'bank.teVerwerken': 'À traiter',
  'bank.verwerkt': 'Traité',
  'bank.voorstel': 'Suggestion',
  'bank.voorstelWaarom': 'Pourquoi cette suggestion ?',
  'bank.koppelen': 'Rapprocher',
  'bank.boeken': 'Comptabiliser',
  'bank.opRekening': 'Comptabiliser sur un compte',
  'bank.reconciliatie': 'Mon solde bancaire correspond-il ?',
  'bank.saldoGrootboek': 'Selon la comptabilité',
  'bank.saldoAfschrift': 'Selon le dernier relevé',
  'bank.verschil': 'Écart',
  'bank.sluitAan': 'Votre solde bancaire correspond à votre comptabilité.',
  'bank.sluitNietAan': 'Il subsiste un écart entre votre relevé et votre comptabilité.',
  'bank.leeg': "Il n'y a pas encore d'opérations bancaires. Importez un relevé pour commencer.",
  'bank.geimporteerd': '{toegevoegd} nouvelles opérations ajoutées, {overgeslagen} étaient déjà présentes.',

  'rapport.titel': 'Chiffres',
  'rapport.balans': 'Bilan',
  'rapport.balansUitleg': 'Ce que votre entreprise possède et doit à une date donnée.',
  'rapport.winstEnVerlies': 'Compte de résultat',
  'rapport.winstEnVerliesUitleg': "Ce qui est entré et sorti au cours d'une période.",
  'rapport.saldibalans': 'Balance générale',
  'rapport.grootboek': 'Grand livre',
  'rapport.journaal': 'Journal',
  'rapport.ouderdom': 'Qui doit encore payer ?',
  'rapport.btw': 'Aperçu de la TVA',
  'rapport.activa': 'Actif',
  'rapport.passiva': 'Passif et capitaux propres',
  'rapport.opbrengsten': 'Produits',
  'rapport.kosten': 'Charges',
  'rapport.resultaat': 'Résultat',
  'rapport.inBalans': 'Le bilan est équilibré.',
  'rapport.nietInBalans': "Attention : le bilan n'est pas équilibré. Contactez l'assistance.",
  'rapport.doorklikken': "Cliquez sur un montant pour voir d'où il provient.",
  'rapport.vorigePeriode': 'Période précédente',
  'rapport.btwVoorbehoud':
    'Cet aperçu est un calcul fondé sur votre comptabilité et ne constitue pas un conseil fiscal. Vérifiez le résultat ou faites-le contrôler avant de déclarer.',
  'rapport.btwTeBetalen': 'À payer',
  'rapport.btwTeVorderen': 'À récupérer',
  'rapport.btwSaldo': 'Solde',
  'rapport.btwAansluiting': 'Rapprochement avec le grand livre',
  'rapport.btwSluitAan': 'Laperçu correspond exactement à votre grand livre.',
  'rapport.geenGegevens': "Il n'y a pas encore d'écritures sur cette période.",

  'instellingen.titel': 'Paramètres',
  'instellingen.administratie': 'Données de votre entreprise',
  'instellingen.gebruikers': 'Qui a accès ?',
  'instellingen.beveiliging': 'Sécurité',
  'instellingen.taal': 'Langue',
  'instellingen.thema': 'Affichage',
  'instellingen.themaLicht': 'Clair',
  'instellingen.themaDonker': 'Sombre',
  'instellingen.themaSysteem': 'Suivre mon système',
  'instellingen.auditTrail': "Que s'est-il passé ?",
  'instellingen.auditUitleg':
    'Chaque action importante est enregistrée et ne peut pas être modifiée après coup.',
  'instellingen.auditControle': "Vérifier la piste d'audit",
  'instellingen.auditOngeschonden': "La piste d'audit est complète et intacte.",
  'instellingen.uitnodigen': 'Inviter quelquun',
  'instellingen.rol': 'Rôle',
  'instellingen.rolWijzigen': 'Modifier le rôle',
  'algemeen.acties': 'Actions',
  'instellingen.nieuweLink': 'Nouveau lien',
  'instellingen.uitnodigingTot': "valable jusqu'au",
  'instellingen.intrekkenVraag': "Retirer l'acces a",
  'instellingen.intrekkenUitleg': "Cette personne n'a plus acces a cette comptabilite. Ce qu'elle a saisi reste, avec son nom dans la piste d'audit. Vous pouvez l'inviter a nouveau plus tard.",
  'instellingen.toegangIntrekken': "Retirer l'accès",
  'instellingen.perioden': 'Périodes',
  'instellingen.periodeBlokkeren': 'Bloquer',
  'instellingen.periodeSluiten': 'Clôturer',
  'instellingen.periodeHeropenen': 'Rouvrir',
  'instellingen.heropenReden': 'Pourquoi cette période doit-elle être rouverte ?',

  'rol.owner': 'Propriétaire',
  'rol.admin': 'Administrateur',
  'rol.bookkeeper': 'Comptable',
  'rol.accountant': 'Expert-comptable',
  'rol.employee': 'Collaborateur',
  'rol.viewer': 'Observateur',
  'rol.support': 'Assistance',

  'fout.validation_failed': 'Quelque chose ne va pas dans les données saisies.',
  'fout.unauthenticated': "Vous n'êtes plus connecté.",
  'fout.mfa_required': 'Une deuxième étape est encore nécessaire.',
  'fout.forbidden': "Vous n'avez pas l'autorisation pour cela.",
  'fout.not_found': "Cela n'existe pas (ou plus).",
  'fout.version_conflict': "Quelqu'un d'autre a modifié cela entre-temps.",
  'fout.duplicate_document': 'Ce document existe déjà.',
  'fout.period_closed': 'Cette période est clôturée.',
  'fout.entry_not_balanced': "L'écriture n'est pas équilibrée.",
  'fout.entry_immutable': 'Cette écriture est définitive et ne peut pas être modifiée.',
  'fout.invoice_requirements_missing': 'La facture ne contient pas toutes les mentions légales.',
  'fout.limit_reached': 'La limite de votre formule est atteinte.',
  'fout.rate_limited': 'Trop de requêtes successives. Réessayez dans un instant.',
  'fout.internal_error': 'Une erreur est survenue de notre côté.',
  'fout.netwerk': "Le serveur n'a pas pu être joint. Vérifiez votre connexion.",
};
